import { cn } from "@/utils/classes";
import { cva } from "class-variance-authority";
import { alertTypeToIcon } from "./alert-type-to-icon";
import { AlertProps } from "./alert.types";
import { createElement } from "react";

/* Variants */
const alertVariants = cva("alert shadow-lg w-full", {
  variants: {
    type: {
      error: "alert-error",
      warning: "alert-warning",
      success: "alert-success",
      info: "alert-info",
      default: "",
    },
  },
  defaultVariants: {
    type: "default",
  },
});

/*
 * Alert component using daisyUI to render different types of alerts
 */
export const Alert = ({ title, description, type = "default", className }: AlertProps) => {
  return (
    <div role="alert" className={cn("alert", alertVariants({ type }), className)}>
      {createElement(alertTypeToIcon[type], { className: "size-6" })}
      <div>
        {title && <p className="font-bold">{title}</p>}
        {description && <p className="text-xs">{description}</p>}
      </div>
    </div>
  );
};
